import { Box, SelectChangeEvent } from "@mui/material";
import { KeydriveTextfield } from "../../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import { useTranslation } from "react-i18next";
import usePrivilegeName from "../../../../../functions/hooks/usePrivilegeName";


interface IEditFolderUserBoxItem {
    userName: string;
    permissionType: number;
}

function EditFolderUserBoxItem({
    userName,
    permissionType,
}: IEditFolderUserBoxItem) {
    const { privilegeName } = usePrivilegeName(permissionType);

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            mb="5px"
            gap={3}
        >
            <KeydriveTextfield 
                value={userName}
                onChange={() => {}}
                label="Usuário"
                disabled
            />
            <KeydriveTextfield
                value={privilegeName}
                onChange={() => {}}
                label="Privilégio"
                disabled
            />
        </Box>
    );
}

export default EditFolderUserBoxItem;